import(/* webpackMode: "eager" */ "/home/janab/freelance/comverse-baseapp-next/app/error.jsx");
